import { ComponentStyleConfig } from '@chakra-ui/react';

export const Form: ComponentStyleConfig = {
  baseStyle: {
    container: {
      borderWidth: '1px',
      borderColor: 'neutral.300',
      backgroundColor: 'white.500',
      borderRadius: '8px',
      padding: '4px 16px',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
    },
    _invalid: {
      container: {
        borderColor: 'error.500',
      },
    },
    _focus: {
      container: {
        borderWidth: '10px',
      },
    },
    helperText: {
      margin: 0,
      padding: 0,
      fontSize: 'sm',
      fontWeight: 400,
    },
  },
};
